<template>
  <div>
    <div id="devis" class="typeDocument">
      <div v-if="proposals.length">
        <b-table class="text-center" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFilteredProposals" responsive :striped="true" :fields="fieldsDevis" :items="proposals" :current-page="currentPageDevis" :per-page="perPage">
          <template v-slot:cell(etat)="data">
            <!-- Brouillon -->
            <b-button v-if="data.item.statut == 0" variant="info" style='font-size:11px; text-transform: uppercase;'>{{ data.item.statut_libelle }}</b-button>
            <!-- Ouverte -->
            <b-button v-if="data.item.statut == 1" variant="warning" style='font-size:11px; text-transform: uppercase;'>{{ data.item.statut_libelle }}</b-button>
            <!-- Signée -->
            <b-button v-if="data.item.statut == 2" variant="success" style='font-size:11px; text-transform: uppercase;'>{{ data.item.statut_libelle }}</b-button>
            <!-- Non signée -->
            <b-button v-if="data.item.statut == 3" variant="secondary" style='font-size:11px; text-transform: uppercase;'>{{ data.item.statut_libelle }}</b-button>
            <!-- Facturée -->
            <b-button v-if="data.item.statut == 4" variant="primary" style='font-size:11px; text-transform: uppercase;'>{{ data.item.statut_libelle }}</b-button>
          </template>
          <template v-slot:cell(date-creation)="data">
            <span style='font-size:12px;'>{{ data.item.date_creation }}</span>
          </template>
          <template v-slot:cell(reference)="data">
            <span style='width:30%; font-size:12px; text-transform: uppercase;'>{{ data.item.ref_client }}</span>
          </template>
          <template v-slot:cell(prix-ht)="data">
            <span style='font-size:12px; text-transform: uppercase;'>{{ data.item.total_ht }}</span>
          </template>
          <template v-slot:cell(prix-ttc)="data">
            <span style='font-size:12px; text-transform: uppercase;'>{{ data.item.total_ttc }}</span>
          </template>
          <template v-slot:cell(document)="data">
            <span style='font-size:12px; text-transform: uppercase;'>{{ data.item.ref+'.pdf' }}</span>
          </template>
		  <template v-slot:cell(modify)="data">
			  <template v-if="data.item.statut == 0">
				<a v-on:click="modifyPropale(data.item.id)"><span style="cursor:pointer;" class='far fa-edit' v-b-tooltip.hover title='Modifier'></span></a>
			</template>
		  </template>
		  <template v-slot:cell(validate)="data">
			  <template v-if="data.item.statut == 0">
				<a v-on:click.stop="validateObject('proposals',data.item.id)"><span style="cursor:pointer;color:green;" class='fas fa-check' v-b-tooltip.hover title='Valider'></span></a>
			</template>
		  </template>
          <template v-slot:cell(download)="data">
            <a v-bind:href="'/api/downloadDoc/'+data.item.last_main_doc" download><span style="cursor:pointer;" class='fas fa-cloud-download-alt' v-b-tooltip.hover title='Télécharger'></span></a>
          </template>
          <template v-slot:cell(visual)="data">
            <a v-on:click.stop="visualDevisTiers(data.item)"><span style="cursor:pointer;" class='far fa-eye' v-b-tooltip.hover title='Visualiser'></span></a>
          </template>
		  <template v-slot:cell(delete)="data">
			  <template v-if="data.item.statut == 0">
				<a v-on:click.stop="deletePropale(data.item.id)"><span style="cursor:pointer;color:red;" class='far fa-trash-alt' v-b-tooltip.hover title='Supprimer'></span></a>
			</template>
		  </template>
        </b-table>
        <div v-if="proposals.length>perPage">
          <b-pagination size="md" :total-rows="proposals.length" v-model="currentPageDevis" :per-page="perPage" />
        </div>
        <div class='actionDevis'>
            <el-button slot="reference" type="success" v-on:click="create" style='font-size:12px;float:right;'>CRÉER UN NOUVEAU DEVIS</el-button>
        </div>
      </div>
      <div v-else>
        <h5>Aucun devis disponibles</h5>
        <div class='actionDevis'>
          <el-button slot="reference" type="success" v-on:click="create" style='font-size:12px;float:right;'>CRÉER UN NOUVEAU DEVIS</el-button>
        </div>
      </div>
    </div>
    <b-modal id="modalVisualDevisTiers" @hide="resetModal" :title="modal.title" hide-footer>
      <template>
        <iframe id="visualDoc" v-bind:src="modal.src"></iframe>
      </template>
    </b-modal>
  </div>
</template>

<script>
import script from '../../../../script/script.js';
import scriptTiers from '../../../../script/script_tiers.js';
import scriptPropale from '../../../../script/script_propale.js';
export default {
  data() {
    return {
      post: {},
      fieldsDevis:[{key:"etat", label:"Statut", sortable: true},{key:"date-creation", label:"Date de création"},{key:"reference", label:"Référence"},{key:"prix-ht", label:"Total(ht*)"},{key:"prix-ttc", label:"Total(ttc*)"},{key:"document", label:"Document"},{key:"modify", label:""},{key:"validate", label:""},{key:"download", label:""},{key:"visual", label:""},{key:"delete", label:""}/*,{key:"comment", label:""}*/],
      currentPageDevis: 1,
      perPage: 10,
      filter:null,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      isDocuments: false,
    }
  },
  mounted:function(){
    this.loadDocuments("proposals");
  },
  methods: {
    verifyRight: script.verifyRight,
    loadDocuments: script.loadDocuments,
    visualDevisTiers: scriptTiers.visualDevisTiers,
    onFilteredProposals(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.proposals.length = filteredItems.length
      this.currentPage = 1
    },
    createPropale: scriptPropale.createPropale,
    deletePropale: scriptTiers.deletePropale,
    validateObject: scriptTiers.validateObject,
    create(){
      let res = confirm("Voulez-vous créer un devis pour ce client ?")
      if(res){
        this.createPropale(this.$route.params.id)
      }
    },
    modifyPropale (id) {
      this.$router.push('../editionDevis/'+this.$route.params.id+"/"+id)
    }
  },
  components: {
  },
  computed : {
    proposals(){
      return this.$store.state.proposals
    },
    modal(){
      return this.$store.state.modalDoc
    }
  }
}
</script>

<style scoped>
.actionDevis{
  text-align: end;
}
</style>

<style>
#modalVisualDevisTiers > .modal-dialog {
  max-width: 50%;
  height: 95%;
  margin-top: 1%;
}

#modalVisualDevisTiers > .modal-dialog > div{
  height: 100%;
}
</style>
